import React, { useCallback, useEffect, useRef } from 'react';
import { PopupMenu, Tooltip, Fab } from '@doxyme/ui';
import { onCallMenuOpen } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { CallMenu } from '../CallMenu';
import * as troubleshooting from '../../../troubleshooting';
import { usePrevious } from '../../../../common/hooks';
import { useIntl } from 'react-intl';
import { noop } from 'lodash';
const TOOLTIP_SHOW_DELAY_MS = 1.5;
export const CallMenuButton = ({ onToggle = noop, hasTooltip = true, isPatient, }) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const isTroubleshootingActive = !!useSelector(troubleshooting.selectors.getStepName);
    const prevIsTroubleshootingActive = usePrevious(isTroubleshootingActive);
    const popupMenuRef = useRef();
    const togglePopupMenu = (isOn) => {
        popupMenuRef.current.toggleMenu(isOn);
    };
    useEffect(() => {
        if (isTroubleshootingActive) {
            togglePopupMenu(true);
        }
        else if (prevIsTroubleshootingActive) {
            togglePopupMenu(false);
        }
    }, [isTroubleshootingActive, prevIsTroubleshootingActive]);
    const onTogglePopupMenu = useCallback((isOpen) => {
        onToggle(isOpen);
        if (isOpen)
            dispatch(onCallMenuOpen());
    }, [onToggle]);
    const onTroubleshootingClose = useCallback(() => {
        togglePopupMenu(false);
    }, [togglePopupMenu]);
    const isDisabled = isTroubleshootingActive;
    return (<PopupMenu onToggle={onTogglePopupMenu} ref={popupMenuRef} isDisabled={isDisabled} anchorEl={hasTooltip ? (<Tooltip showTimeout={TOOLTIP_SHOW_DELAY_MS} size="medium" theme="grey" pointerPosition="top-center" positionShift={7} isInteractive={false} borderRadius={16} isDefaultTriggerPadding={false} content={intl.formatMessage({ id: 'call.actions.options.label' })}>
            <Fab isDisabled={isDisabled} icon="menu-kebab"/>
          </Tooltip>) : (<Fab isDisabled={isDisabled} icon="menu-kebab"/>)}>
      {!isTroubleshootingActive ? (<CallMenu toggleMenu={togglePopupMenu} isPatient={isPatient}/>) : (<troubleshooting.TroubleshootingWizard isPatient={isPatient} onClose={onTroubleshootingClose}/>)}
    </PopupMenu>);
};
